import Button from '@mui/material/Button';
import { useRouter } from 'next/router';
import { PATH_NAME } from '../../../../configs/pathName';
import { ROLE_ACCESS, TRoleAccess } from '../../../../constant/storage';
import { GroupSuggestionActionEnum } from '../../../../interfaces/training.interface';
import { QuickLoginModalHOC } from '../../../modal/LoginModal2HOC';
import { FilledChecked } from '../../svgIcon/filled';
import { roleLabelMapper } from './GroupSuggestion';

export const JoinButtonDesktop = ({
  handleClick,
  handleJoinGroup,
  groupId,
  action,
  joined,
  role,
}: {
  handleClick: Function;
  groupId: string;
  action: GroupSuggestionActionEnum;
  handleJoinGroup: Function;
  joined: boolean | undefined;
  inSearch: boolean;
  role: TRoleAccess | undefined;
}) => {
  const router = useRouter();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <QuickLoginModalHOC
        handleClickWhenDisabledQuickLogin={handleClick}
        loginSuccessCb={async () => {
          router.push({
            pathname: PATH_NAME.MY_GROUPS_DETAIL,
            query: {
              gid: groupId,
            },
          });
          handleJoinGroup();
        }}
      >
        {action == GroupSuggestionActionEnum.JoinGroup && (
          <Button
            disabled={joined}
            className={`!border !normal-case !h-full !px-[10px] !py-[7px] !bg-transparent !text-Primary/Main hover:!bg-[#009FE433] hover:!text-Primary/Main !border-[#E0E0E0] !border-solid !rounded-[20px] ${
              joined ? ' !text-[#7C7C7C]' : ' !text-[#0086C9]'
            } !bg-transparent !text-xs !font-semibold !leading-4 flex gap-x-2 disabled:!bg-bg_disabled`}
          >
            {joined && <FilledChecked className="ml-1" />}
            {joined ? 'Đã tham gia' : 'Tham gia'}
          </Button>
        )}
        {action == GroupSuggestionActionEnum.ShowRole && (
          <p className="font-semibold text-xs text-[#A8A8A8]">
            {roleLabelMapper[role as ROLE_ACCESS]}
          </p>
        )}
      </QuickLoginModalHOC>
    </div>
  );
};

export const JoinButtonMobile = ({
  handleClick,
  handleJoinGroup,
  groupId,
  action,
  joined,
  role,
}: {
  handleClick: Function;
  groupId: string;
  action: GroupSuggestionActionEnum;
  handleJoinGroup: Function;
  joined: boolean | undefined;
  role: TRoleAccess | undefined;
}) => {
  const router = useRouter();
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <QuickLoginModalHOC
        handleClickWhenDisabledQuickLogin={handleClick}
        loginSuccessCb={async () => {
          router.push({
            pathname: PATH_NAME.MY_GROUPS_DETAIL,
            query: {
              gid: groupId,
            },
          });
          handleJoinGroup();
        }}
      >
        {action == GroupSuggestionActionEnum.JoinGroup && (
          <Button
            disabled={joined}
            className={`!border !normal-case !h-full !px-[10px] !py-[7px] !bg-transparent !text-Primary/Main hover:!bg-[#009FE433] hover:!text-Primary/Main !border-[#E0E0E0] !border-solid !rounded-[20px]  ${
              joined ? '!text-[#7C7C7C]' : ' !text-[#0086C9]'
            }  !bg-[#B1E7FF33] !text-xs !font-semibold !leading-4 disabled:!bg-bg_disabled`}
          >
            {joined ? 'Đã tham gia' : 'Tham gia'}
          </Button>
        )}
        {action == GroupSuggestionActionEnum.ShowRole && (
          <p className="font-semibold text-xs text-[#A8A8A8]">
            {roleLabelMapper[role as ROLE_ACCESS]}
          </p>
        )}
      </QuickLoginModalHOC>
    </div>
  );
};
